import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import Vue from "vue";
import axios from "axios";

// initial state
const state = {
  rechnungen: [],
  eigeneRechnungen: [],
  loading: false,
  loaded: false,
  loadedEigene: false,
  error: null,
};

// getters
const getters = {
  rechnungen(state) {
    return state.rechnungen;
  },
  nutzerRechnungen: (state) => (user) => {
    let rechnungen = [];
    if (state.rechnungen.length > 0) {
      state.rechnungen.forEach((rechnung) => {
        if (rechnung.bbrID === user) {
          rechnungen.push(rechnung);
        }
      });
    } else {
      state.eigeneRechnungen.forEach((rechnung) => {
        if (rechnung.bbrID === user) {
          rechnungen.push(rechnung);
        }
      });
    }
    return rechnungen;
  },
  nutzerRechnungenOffen: (state) => (user) => {
    let rechnungen = [];
    state.eigeneRechnungen.forEach((rechnung) => {
      if (rechnung.bbrID === user && (rechnung.status === "Offen" || rechnung.status === "Überfällig")) {
        rechnungen.push(rechnung);
      }
    });
    return rechnungen;
  },
  statusRechnungenKasse: (state) => (status, kasse) => {
    let rechnungen = [];
    state.rechnungen.forEach((rechnung) => {
      if (rechnung.status === status && rechnung.kasse === kasse) {
        rechnungen.push(rechnung);
      }
    });
    return rechnungen;
  },
  statusRechnungenLetztesDatum: (state) => (kasse) => {
    let rechnungen = [];
    if (state.rechnungen.length > 0) {
      let datum = state.rechnungen[0].rechnung_datum;
      state.rechnungen.forEach((rechnung) => {
        if (rechnung.rechnung_datum) {
          if (rechnung.rechnung_datum === datum && rechnung.kasse === kasse) {
            rechnungen.push(rechnung);
          }
        } else {
          console.log(rechnung);
        }
      });
    }
    return rechnungen;
  },
  rechnungenKasse: (state) => (kasse) => {
    let rechnungen = [];
    state.rechnungen.forEach((rechnung) => {
      if (rechnung.kasse === kasse) {
        rechnungen.push(rechnung);
      }
    });
    return rechnungen;
  },
  statusRechnungen: (state) => (status) => {
    let rechnungen = [];
    state.rechnungen.forEach((rechnung) => {
      if (rechnung.status === status) {
        rechnungen.push(rechnung);
      }
    });
    return rechnungen;
  },
  nutzerRechnung: (state) => (id) => {
    return state.eigeneRechnungen.find((rechnung) => rechnung.id === id);
  },
  rechnung: (state) => (id) => {
    return state.rechnungen.find((rechnung) => rechnung.id === id);
  },
  rechnungNummer: (state) => (nummer) => {
    return state.rechnungen.find((rechnung) => rechnung.rechnungsnummer === nummer);
  },
  loading(state) {
    return state.loading;
  },
  error(state) {
    return state.error;
  },
};

// actions
const actions = {
  loadRechnungen({ commit }) {
    commit("setLoading", true);
    console.log("Rechnungen laden...");
    firebase
      .firestore()
      .collection("vereine")
      .doc(Vue.prototype.$vars.verbindung)
      .collection("rechnungen")
      .orderBy("rechnung_datum", "desc")
      .onSnapshot(
        (snapshot) => {
          const rechnungen = [];
          snapshot.forEach((doc) => {
            rechnungen.push({
              ...doc.data(),
              id: doc.id,
            });
            commit("setLoadedRechnungen", rechnungen);
            commit("setLoading", false);
            commit("setLoaded", true);
          });
        },
        (error) => {
          console.log(error);
          commit("setLoading", false);
        }
      );
  },
  loadEigeneRechnungen({ commit }, user) {
    commit("setLoading", true);
    console.log("Eigene Rechnungen laden...");
    firebase
      .firestore()
      .collection("vereine")
      .doc(Vue.prototype.$vars.verbindung)
      .collection("rechnungen")
      .where("bbrID", "==", user.user)
      .onSnapshot(
        (snapshot) => {
          const rechnungen = [];
          snapshot.forEach((doc) => {
            rechnungen.push({
              ...doc.data(),
              id: doc.id,
            });
            commit("setLoadedEigeneRechnungen", rechnungen);
            commit("setLoading", false);
            commit("setLoadedEigene", true);
          });
        },
        (error) => {
          console.log(error);
          commit("setLoading", false);
        }
      );
  },
  async createRechnung({ commit, dispatch }, payload) {
    // 'dispatch' hinzugefügt, um andere Actions aufzurufen
    try {
      // --- Start der Datentransformation ---
      // Die API erwartet ein anderes Datenformat als Firebase
      // Wir bereiten beide Payloads hier vor
      console.log(payload);
      // Für Firestore: Timestamp-Objekte und DocumentReference
      const apiPayload = {
        art: payload.rechnung_art,
        betrag: payload.positionen.reduce((total, pos) => total + pos.betrag, 0),
        created_at: new Date(),
        freitext: payload.rechnung_freitext,
        freitext_html: payload.rechnung_freitext.replace(/\n/g, "<br>"),
        kasse: payload.kasse,
        log: [],
        nummer: payload.rechnungsnummer,
        positionen: payload.positionen.map((pos) => ({
          anzahl: 1,
          betrag: pos.betrag,
          summe: pos.betrag,
          was: pos.was,
        })),
        rechnung_datum: payload.rechnung_datum,
        status: payload.status,
        titel: payload.rechnung_titel,
        user_id: payload.bbrID,
        zahlbar_bis: payload.rechnung_zahlbar_bis,
      };
      console.log("Firestore-Payload vorbereitet:", apiPayload);
      // --- Ende der Datentransformation ---

      // Füge die Rechnung mit dem umgewandelten Firestore-Payload hinzu
      const docRef = await firebase
        .firestore()
        .collection("vereine")
        .doc(Vue.prototype.$vars.verbindung)
        .collection("rechnungen")
        .add(payload);
      console.log("Rechnung erfolgreich in Firebase erstellt mit ID:", docRef.id);

      // --- HIER WIRD DER HEALTH-ENDPUNKT GETRIGGERT ---
      console.log("Starte Health-Check-API-Aufruf nach Rechnungserstellung...");
      try {
        const response = await axios.post(
          "https://us-central1-korpodesk.cloudfunctions.net/api/v1/rechnungen/createRechnung",
          apiPayload, // Verwende den umgewandelten API-Payload
          {
            // Hier übergibst du die Header im Konfigurationsobjekt
            headers: {
              "x-organization": "rbo.localhost",
              "x-auth": "oldBierwart",
              Authorization: "Bearer meinSuperGeheimerToken123",
              "Content-Type": "application/json",
            },
          }
        );
        console.log("Health-API-Antwort:", response.data);
      } catch (apiError) {
        console.error("Fehler beim Aufruf des Health-Endpunkts nach Rechnungserstellung:", apiError);
      }
      // --- ENDE DES HEALTH-ENDPUNKT-TRIGGERS ---

      commit("createRechnung", {
        ...payload,
        id: docRef.id,
      });
    } catch (firebaseError) {
      console.error("Fehler beim Erstellen der Rechnung in Firebase:", firebaseError);
      commit("setError", firebaseError.message);
    }
  },
  deleteRechnungData({ commit }, payload) {
    commit("setLoading", true);
    firebase
      .firestore()
      .collection("vereine")
      .doc(Vue.prototype.$vars.verbindung)
      .collection("rechnungen")
      .doc(payload)
      .delete()
      .then(() => {
        commit("setLoading", false);
        commit("deleteRechnung", payload);
      })
      .catch((error) => {
        console.log(error);
        commit("setLoading", false);
      });
    commit("setLoading", false);
  },
  updateRechnungData({ commit }, payload) {
    commit("setLoading", true);
    const updateObj = {};
    Object.keys(payload).forEach((key) => {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key];
      }
    });
    firebase
      .firestore()
      .collection("vereine")
      .doc(Vue.prototype.$vars.verbindung)
      .collection("rechnungen")
      .doc(payload.id)
      .update(updateObj)
      .then(() => {
        commit("setLoading", false);
        commit("updateRechnung", payload);
      })
      .catch((error) => {
        console.log(error);
        commit("setLoading", false);
      });
  },
};

// mutations
const mutations = {
  setLoadedRechnungen(state, payload) {
    state.rechnungen = payload;
  },
  setLoadedEigeneRechnungen(state, payload) {
    state.eigeneRechnungen = payload;
  },
  createRechnung(state, payload) {
    state.rechnungen.push(payload);
  },
  updateRechnung(state, payload) {
    const rechnung = state.rechnungen.find((rechnung) => {
      return rechnung.id === payload.id;
    });
    // Sicherstellen, dass das Objekt existiert, bevor versucht wird, Eigenschaften zu aktualisieren
    if (rechnung) {
      Object.keys(payload).forEach((key) => {
        // payload[key] könnte undefined sein, aber wir wollen nur tatsächliche Werte überschreiben
        // Prüfen, ob der Schlüssel im Payload vorhanden ist, nicht ob der Wert falsy ist
        if (Object.prototype.hasOwnProperty.call(payload, key)) {
          Vue.set(rechnung, key, payload[key]); // Vue.set verwenden, um Reaktivität sicherzustellen
        }
      });
    }
  },
  deleteRechnung(state, payload) {
    // Array.filter ist oft eine sauberere Methode
    state.rechnungen = state.rechnungen.filter((rechnung) => rechnung.id !== payload);
  },
  setLoading(state, payload) {
    state.loading = payload;
  },
  setLoaded(state, payload) {
    state.loaded = payload;
  },
  setLoadedEigene(state, payload) {
    state.loadedEigene = payload;
  },
  setError(state, payload) {
    state.error = payload;
  },
  clearError(state) {
    state.error = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/rechnungen_alt.js